<template>
  <div class="cashier-modal-overlay" @click.self="$emit('close')">
    <div class="cashier-modal cashier-modal--small" @click.stop>
      <div class="cashier-modal__header">
        <h5>Підтвердження видалення</h5>
        <button type="button" class="close-btn" @click="$emit('close')">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="cashier-modal__body text-center">
        <p>Ви впевнені, що хочете видалити касира <strong>{{ item && item.full_name }}</strong>?</p>
      </div>
      <div class="cashier-modal__footer justify-content-center">
        <b-button variant="secondary" size="sm" @click="$emit('close')" class="mr-2">
          Скасувати
        </b-button>
        <b-button variant="danger" size="sm" @click="$emit('confirm')" :disabled="isDeleting">
          <i v-if="isDeleting" class="fa fa-spinner fa-spin mr-1"></i>
          Видалити
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CashierDeleteModal',
  props: {
    item: {
      type: Object,
      default: null,
    },
    isDeleting: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.cashier-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1060;
}

.cashier-modal {
  background: #fff;
  border-radius: 8px;
  width: 400px;
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid #dee2e6;
    background: #f8f9fa;

    h5 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
    }

    .close-btn {
      border: none;
      background: none;
      font-size: 18px;
      color: #6c757d;
      cursor: pointer;
      padding: 0;
      line-height: 1;

      &:hover {
        color: #343a40;
      }
    }
  }

  &__body {
    padding: 16px;
  }

  &__footer {
    display: flex;
    justify-content: center;
    padding: 12px 16px;
    border-top: 1px solid #dee2e6;
    background: #f8f9fa;
  }
}
</style>
